import {Component, OnInit} from '@angular/core';
import { ModalController, NavController } from "@ionic/angular/standalone";
import { IonToolbar, IonTitle, IonLabel, IonItem, IonInput, IonIcon, IonNote, IonGrid, IonRow, IonCol, IonButton } from '@ionic/angular/standalone';
import { FormBuilder, FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from "@angular/forms";
import {NotificationService} from "../../../services/notification.service";
import {LocalStorageService} from "../../../services/local-storage.service";
import {ModalRoleEnum} from "../../enums/modal-enum";
import {emailRegex} from "../../constants/regex";
import {catchError, finalize, of, switchMap, takeUntil, tap} from "rxjs";
import { HttpErrorResponse } from "@angular/common/http";
import {ManageErrorService, RequestTypesEnum} from "../../../services/manage-error.service";
import {
  AutenticazioneService,
  LoginResponse, AccountService


} from "../../../core/api/generated";
import {LoaderService} from "../../../services/loader.service";
import {PathEnum} from "../../enums/path-enum";
import {UnsubscribeOnDestroy} from "../../abstracts/unsubscribe-on-destroy";
import {TranslocoModule, TranslocoService, provideTranslocoScope} from '@jsverse/transloco';


@Component({
    selector: 'app-recover-password-modal',
    templateUrl: './recover-password-modal.component.html',
    styleUrls: ['./recover-password-modal.component.scss'],
    imports: [IonToolbar, IonTitle, IonLabel, IonItem, IonInput, IonIcon, IonNote, IonGrid, IonRow, IonCol, IonButton, FormsModule, ReactiveFormsModule, TranslocoModule],
    providers: [provideTranslocoScope('shared')]
})
export class RecoverPasswordModalComponent extends UnsubscribeOnDestroy  implements OnInit {

  modalForm: any;
  formGroup: FormGroup = new FormGroup<any>({});
  isConfirmButtonVisible = true;
  isCancelButtonVisible = true;
  /** Messaggio d'errore in-modale persistente: la modale resta aperta per consentire un nuovo
   *  tentativo (correzione email) con feedback visibile, non solo toast volatile. Vedi spec ui-feedback. */
  errorMessage: string | null = null;
  // isConfirmRecoverButtonVisible: boolean = true;
  // isConfirmLoginButtonVisible: boolean = false;

  constructor(private modalController: ModalController,
              private fb: FormBuilder,
              private authService: AutenticazioneService,
              private userControllerService: AccountService,
              private manageErrorService: ManageErrorService,
              private loaderService: LoaderService,
              public navCtrl: NavController,
              private notificationService: NotificationService,
              private localStorageService: LocalStorageService,
              private transloco: TranslocoService) {
    super();
    this.formGroup = this.fb.group({
      email: [null, [Validators.required, Validators.pattern(new RegExp(emailRegex))]],
      password: [null, Validators.required],
    });
  }

  ngOnInit() {
  }

  cancel() {
    return this.modalController.dismiss(null, ModalRoleEnum.CANCEL);
  }

  confirmRecoverPassword() {
    this.errorMessage = null;
    this.loaderService.showLoaderObserve$().pipe(
      // TODO SERVIZIO PROVVISORIO DA MODIFICA VERIFICARE
      switchMap(() => this.userControllerService.resetPasswordAccount({ userEmailRequest: { email: this.ctrlEmail().value }, xRecaptchaToken: '' })),
      finalize(() => this.loaderService.hideLoader())
    ).subscribe({
      next: value => {
        this.notificationService.openToast({message: this.transloco.translate('shared.recover_password.successo'), color: 'success'});
        this.modalController.dismiss(true, ModalRoleEnum.CONFIRM);
      },
      error: (err: HttpErrorResponse) => {
        // Modale tenuta aperta (l'utente può correggere l'email e riprovare): feedback sia toast
        // sia banner in-modale persistente. Testo BE-first dalla fonte unica. Vedi spec ui-feedback.
        this.manageErrorService.manageError(err, RequestTypesEnum.ERRORE_RECUPERA_PASSWORD);
        this.errorMessage = this.manageErrorService.resolveMessage(err, RequestTypesEnum.ERRORE_RECUPERA_PASSWORD);
      }
    })
  }

  ctrlEmail() {
    return this.formGroup.get('email') as FormControl;
  }

  ctrlPassword() {
    return this.formGroup.get('password') as FormControl;
  }
}

